export default __webpack_public_path__ + "static/IB-39d83f94b2a43bda62f5ad34e5f81477.jpg";